import { useAssistantAutocompleteQuery } from '../../query/useAssistantAutocompleteQuery';
import { mergeText } from '../MqlHelper';

export const useSuggestionByIndex = (
    isMql: boolean,
    index: number,
    input: string | undefined,
    enterpriseIds: string[] | undefined
) => {
    const { data: autocomplete } = useAssistantAutocompleteQuery(input ?? '', enterpriseIds ?? [], isMql);

    if (!isMql) {
        return '';
    }
    const safeIndex = index < 0 ? 0 : index;

    const suggestionText = autocomplete.allSuggestions?.[safeIndex]?.text ?? '';

    const merged = mergeText(input ?? '', suggestionText);
    return input ? merged : '';
};
